






import { Component, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import OpensRunNotificationsModal from '@/components/mixins/OpensRunNotificationsModal';
import OpensNotificationModal from '@/components/mixins/OpensNotificationModal';
import axios from 'axios';
import { Run } from '@/core/interfaces/run';
import { Notification } from '@/core/interfaces/notification';

@Component({})
export default class App extends mixins(OpensRunNotificationsModal, OpensNotificationModal) {
    @Watch('$route.query', { immediate: true })
    watchRun(): void {
        if (this.$route.query.run) {
            this.openRun(Number(this.$route.query.run), this.$route.query.notification ? Number(this.$route.query.notification) : undefined);
        } else if (this.$route.query.notification) {
            this.openNotification(Number(this.$route.query.notification));
        }
    }

    async openRun(runId: number, notificationId?: number): Promise<void> {
        return this.openRunNotificationsModal(
            (await axios.get<Run>(`/notification-runs/${runId}`)).data,
            notificationId,
            () => this.$router.push({
                query: {
                    run: undefined,
                    notification: undefined,
                },
            }),
        );
    }

    async openNotification(notificationId: number): Promise<void> {
        return this.openNotificationModal(
            (await axios.get<Notification>(`/notifications/${notificationId}`)).data,
            () => this.$router.push({
                query: {
                    notification: undefined,
                },
            }),
        );
    }
}

